/** 页面场景契约：用于两套渲染入口的同一套标题、任务语义和上下文导航。 */
export interface PageScene {
  path: string;
  title: string;
  category: string;
  description: string;
  related: string[];
}
export const PAGE_SCENES: PageScene[] = [
  {
    path: '/notifications',
    title: '站内消息',
    category: '工作空间',
    description: '查看发给我的业务提醒、审批结果与企业风险信息。',
    related: ['/followups'],
  },
  {
    path: '/',
    title: '今日工作',
    category: '工作空间',
    description: '粘贴微信文字、上传图片或表格，让 AI 整理成可报价草稿。',
    related: ['/inquiries', '/followups', '/overview'],
  },
  {
    path: '/customers',
    title: '客户管理',
    category: '客户协作',
    description: '找到客户，接续沟通，把下一步落到具体行动。',
    related: ['/inquiries', '/followups'],
  },
  {
    path: '/inquiries',
    title: '询价管理',
    category: '售前作业',
    description: '接入图纸与客户原话，确认关键规格后开始报价。',
    related: ['/quotations'],
  },
  {
    path: '/quotations',
    title: '报价管理',
    category: '售前作业',
    description: '从草稿核价到客户发出，每个版本都有清晰的下一步。',
    related: ['/inquiries', '/proposals'],
  },
  {
    path: '/approvals',
    title: '报价审批',
    category: '经营决策',
    description: '结合申请原因与成本依据，决定这份报价能否发出。',
    related: ['/quotations'],
  },
  {
    path: '/automation',
    title: '业务自动化',
    category: '工作空间',
    description: '从询价、报价到交付与复购，把业务信号变成可执行的下一步。',
    related: ['/followups', '/orders', '/config/reminders'],
  },
  {
    path: '/followups',
    title: '销售跟进',
    category: '今日行动',
    description: '先处理到期承诺，再安排下一次客户沟通。',
    related: ['/customers', '/renewals'],
  },
  {
    path: '/overview',
    title: '经营概览',
    category: '经营决策',
    description: '查看本期业务发生量、当前待处理事项，并追溯到真实业务明细。',
    related: ['/automation', '/quotations', '/orders'],
  },
  {
    path: '/orders',
    title: '订单跟踪',
    category: '客户协作',
    description: '追踪交付进度与回款记录，及时兑现客户承诺。',
    related: ['/samples', '/renewals'],
  },
  {
    path: '/contracts',
    title: '合同到期',
    category: '客户协作',
    description: '按明确合同来源与到期日期跟踪续约，保留变更依据。',
    related: ['/customers', '/followups'],
  },
  {
    path: '/renewals',
    title: '复购机会',
    category: '客户协作',
    description: '按预计采购时间安排回访，让老客户的下一单有着落。',
    related: ['/customers', '/followups'],
  },
  {
    path: '/competitors',
    title: '竞品价格',
    category: '销售知识',
    description: '对照同类规格与信息来源，为客户沟通准备依据。',
    related: ['/knowledge', '/quotations'],
  },
  {
    path: '/proposals',
    title: '报价方案',
    category: '售前作业',
    description: '把产品选型、交期和报价说明整理成客户能看懂的方案。',
    related: ['/quotations', '/knowledge'],
  },
  {
    path: '/samples',
    title: '打样跟踪',
    category: '客户协作',
    description: '从打样申请到客户反馈，让验证结果回到订单推进。',
    related: ['/orders', '/followups'],
  },
  {
    path: '/knowledge',
    title: '企业知识库',
    category: '销售知识',
    description: '查产品、找案例、回答客户，每个答案都保留出处。',
    related: ['/terms', '/competitors'],
  },
  {
    path: '/config/company',
    title: '企业信息',
    category: '团队管理',
    description: '报价单抬头与落款上的企业名称、回联电话、地址与信用代码。',
    related: ['/members', '/profile'],
  },
  {
    path: '/config/model',
    title: 'AI 配置',
    category: '团队管理',
    description: '配置可用的智能服务，核对连接状态与能力范围。',
    related: ['/audit/ai', '/knowledge'],
  },
  {
    path: '/materials',
    title: '材料库',
    category: '地基维护',
    description: '材料台账与价格时间序列。价格只追加，取价按生效日，过期即阻断报价。',
    related: ['/quotations', '/terms'],
  },
  {
    path: '/config/parameters',
    title: '核价参数',
    category: '地基维护',
    description: '折间距、滤料余量、型材米重这类按产品族的算料参数。发布之后不可改，改就是发新版。',
    related: ['/materials', '/golden'],
  },
  {
    path: '/golden',
    title: '核价样本',
    category: '地基维护',
    description: '对照历史报价逐项复核核价结果；差异需注明依据并由负责人确认。',
    related: ['/materials', '/quotations'],
  },
  {
    path: '/terms',
    title: '产品别名与标准映射',
    category: '销售知识',
    description: '统一客户叫法与标准产品字段，用于询价识别。',
    related: ['/knowledge', '/inquiries'],
  },
  {
    path: '/config/reminders',
    title: '提醒规则',
    category: '团队管理',
    description: '设置提醒时机与适用范围，让团队只收到可行动的提醒。',
    related: ['/followups', '/renewals'],
  },
  {
    path: '/audit/ai',
    title: 'AI 用量与审计',
    category: '经营追溯',
    description: '查看调用、费用和失败记录，定位需要处理的异常。',
    related: ['/config/model', '/overview'],
  },
  {
    path: '/members',
    title: '员工管理',
    category: '团队管理',
    description: '创建员工账号、重置密码、绑定微信并完成离职交接。',
    related: ['/config/company', '/profile'],
  },
  {
    path: '/profile',
    title: '我的资料',
    category: '个人空间',
    description: '核对个人身份、所在企业和常用设置。',
    related: ['/'],
  },
];
export function sceneForPath(path: string): PageScene | undefined {
  return (
    PAGE_SCENES.find((s) => s.path === path) ??
    PAGE_SCENES.filter((s) => s.path !== '/')
      .sort((a, b) => b.path.length - a.path.length)
      .find((s) => path.startsWith(`${s.path}/`))
  );
}
const OWNER_PATHS = ['/approvals', '/config/', '/members', '/audit/'];
export function canDiscoverPage(path: string, owner: boolean): boolean {
  return owner || !OWNER_PATHS.some((p) => (p.endsWith('/') ? path.startsWith(p) : path === p));
}
